<div class="cart-clear-confirmation">
  <div class="text-h6-s text-md-h4-s color-black">
    очистить корзину
    @if (!isMobileSmDown()) {
      ?
    }
  </div>
  <div class="text-c1-l-300 text-md-b4-l-300 color-black">вернуть товары обратно не получится</div>
  <button sdButton type="button" [theme]="buttonThemes.Outlined" (click)="removeAllEntries()">удалить</button>
</div>
